import { render } from "./Main.vue?vue&type=template&id=53b9c922&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=53b9c922&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=53b9c922&scope=true&lang=css"
script.render = render
script.__scopeId = "data-v-53b9c922"

export default script